import { render, staticRenderFns } from "./GroupAddDialog.vue?vue&type=template&id=059d49ae&scoped=true"
import script from "./GroupAddDialog.vue?vue&type=script&lang=js"
export * from "./GroupAddDialog.vue?vue&type=script&lang=js"
import style0 from "./GroupAddDialog.vue?vue&type=style&index=0&id=059d49ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059d49ae",
  null
  
)

export default component.exports